module.exports = __webpack_public_path__ + "static/UnclickFlightIssue-b97c3190169354a40e726438f3b8284a.png";